(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sw-shared-style"]) return;
  try {
    
document.querySelectorAll(".swp-menu a").forEach(a=>a.addEventListener("click",()=>a.closest("details").open=false));document.addEventListener("keydown",e=>{if(e.key==="Escape")document.querySelectorAll(".swp-menu[open]").forEach(d=>{d.open=false;d.querySelector("summary").focus()})});

  } catch(e) { console.error(e); }
})();
})();
